import { createSlice } from "@reduxjs/toolkit";

export const setObject = createSlice({
  name: "data",
  initialState: {
    value: [],
    discounts: [],
    formFields: [],
    ledgerAccounts: [],
    subCat: [],
    products: [],
    contacts: [],
    sideCardData: {},
    gridView: "",
    status: "create",
  },
  reducers: {
    addObject: (state, action) => {
      state.value = action.payload;
    },
    addDiscount: (state, action) => {
      state.discounts = action.payload;
    },
    addFormField: (state, action) => {
      state.formFields = action.payload;
    },
    addLedgerAccounts: (state, action) => {
      state.ledgerAccounts = action.payload;
    },
    addSubCategorys: (state, action) => {
      state.subCat = action.payload;
    },
    addProducts: (state, action) => {
      state.products = action.payload;
    },
    addAllContacts: (state, action) => {
      state.contacts = action.payload;
    },
    addSideCardData: (state, action) => {
      state.sideCardData = action.payload;
    },
    changeStatus: (state, action) => {
      state.status = action.payload;
    },
    changeView: (state, action) => {
      state.gridView = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addObject,
  addDiscount,
  addFormField,
  addLedgerAccounts,
  addSubCategorys,
  addAllContacts,
  addProducts,
  addSideCardData,
  changeView,
  changeStatus,
} = setObject.actions;

export default setObject.reducer;
